import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import ThemeProvider from './components/ThemeProvider';
import { registerPwa } from './pwa';
import { reportClientError } from './utils/telemetry';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
  reportClientError({
    message: `Unhandled promise rejection: ${event.reason?.message || String(event.reason)}`,
    stack: event.reason?.stack,
  });
});

window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
  reportClientError({
    message: `Global error: ${event.error?.message || event.message || 'Unknown'}`,
    stack: event.error?.stack,
  });
});

// 注册 PWA（桌面端会自动跳过，见 src/pwa.ts 约束 1）
registerPwa();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
